import { Injectable } from '@angular/core';
import { BaseService } from '../../common/services/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SelectBy } from '../../common/interfaces/sort-by.interface';
import { ContactPerson } from '../../common/interfaces/contact-person.interface';
import { PhoneNumber } from '../../common/interfaces/phone-number.interface';

@Injectable()
export class CommonContactPersonService extends BaseService {

    constructor(private http: HttpClient) {
        super();
    }

    create(contactPerson: ContactPerson): Observable<any> {
        const body = this.cloneAndRemoveNulls({
            ...contactPerson,
            phone:  new PhoneNumber(contactPerson.phone as PhoneNumber).toString(),
            mobilePhone: new PhoneNumber(contactPerson.mobilePhone as PhoneNumber).toString()
        });

        return this.http.post(this.getApiUrl() + '/contactpersons', body);
    }

    findAll(state: string): Observable<ContactPerson[]> {
        const sortBy: SelectBy = {order: 'ASCENDING', type: 'LAST_NAME'};
        let params = this.getSortHeaders(sortBy);
        params = params.append('state', state);
        return this.http.get(this.getApiUrl() + '/contactpersons', { params })
            .pipe(
                map((res: any) => res || []),
                map((contactPersons: ContactPerson[]) => contactPersons.map((cp: ContactPerson) =>
                    ({
                        ...cp,
                        phone: PhoneNumber.fromData(cp.phone as string),
                        mobilePhone: PhoneNumber.fromData(cp.mobilePhone as string)
                    })
                ))
            );
    }

    findOne(id: string): Observable<ContactPerson> {
        return this.http.get(this.getApiUrl() + '/contactpersons/' + id)
            .pipe(
                catchError(() => of({} as ContactPerson)),
                map((res: any) => res || {}),
                map((contactPerson: ContactPerson) => ({
                        ...contactPerson,
                        phone: PhoneNumber.fromData(contactPerson?.phone as string),
                        mobilePhone: PhoneNumber.fromData(contactPerson?.mobilePhone as string)
                }))
            );
    }
}
